import React from "react";
import "./About.css";
import { Type } from "./Type";
import GitHubIcon from "@material-ui/icons/GitHub";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import EmailIcon from "@material-ui/icons/Email";
import PhoneIcon from "@material-ui/icons/Phone";
import FacebookIcon from "@material-ui/icons/Facebook";
import DescriptionIcon from "@material-ui/icons/Description";
import PublicIcon from "@material-ui/icons/Public";
import { Introduction } from "./Introduction";
import { Timeline } from "./Timeline";
import { Techstacks } from "./Techstacks";
export const About = () => {
  return (
    <>
      <div className="about center">
        <h1 data-aos="fade-right">
          Hi, I am <span className="about__name">Shilajit Paul</span>
        </h1>
        <Type />
        {/* <p className="about__desc" data-aos="fade-right">
        A passionate Full-Stack Web Developer and a JavaScript enthusiast who loves to create smart and highly polished
        interfaces for the web with hands on experience in designing, developing and maintaining projects. Highly skilled
         in 
        collaboration, decision-making and Data structure & Algorithms. 
        Looking forward to work on exciting projects that
        can help in making people's lives better and comfortable.
         
        </p> */}
        <div className="about__contact center">
          <a
            href="https://github.com/iShilajit"
            aria-label="github"
            target="_blank"
            rel="noreferrer"
            className="link link--icon"
          >
            <GitHubIcon />
          </a>
          <a
            href="mailto:shilajit2014paul@gmail.com"
            target="_blank"
            rel="noreferrer"
            aria-label="github"
            className="link link--icon"
          >
            <EmailIcon />
          </a>
          <a
            href="tel:+919804852663"
            target="_blank"
            rel="noreferrer"
            aria-label="github"
            className="link link--icon"
          >
            <PhoneIcon />
          </a>
          <a
            href="https://www.linkedin.com/in/shilajit-paul-a7aba7153/"
            aria-label="github"
            className="link link--icon"
            target="_blank"
            rel="noreferrer"
          >
            <LinkedInIcon />
          </a>
          <a
            href="https://drive.google.com/file/d/1nNtRp5zmBIg73uW1qneasxXt1nXNSojF/view?usp=sharing"
            aria-label="github"
            className="link link--icon"
            target="_blank"
            rel="noreferrer"
          >
            <DescriptionIcon />
          </a>
          <a
            href="https://www.facebook.com/shilajit.paul.1"
            aria-label="github"
            className="link link--icon"
            target="_blank"
            rel="noreferrer"
          >
            <FacebookIcon />
          </a>
          <a
            href="https://www.google.co.in/maps/place/Chandannagar,+West+Bengal/@22.8616353,88.3509187,14z/data=!3m1!4b1!4m5!3m4!1s0x39f891c05d059fa9:0x516c5f246932de74!8m2!3d22.867114!4d88.3674381?hl=en"
            aria-label="github"
            className="link link--icon"
            target="_blank"
            rel="noreferrer"
          >
            <PublicIcon />
          </a>
        </div>
      </div>
      <Introduction />
      <Timeline />
      <section id="#skills">
        <Techstacks />
      </section>
    </>
  );
};
